export const FULFILLMENT_IN_PROGRESS_KEY = 'prodmove_fulfillment_in_progress';
export const FULFILLMENT_GUARD_TTL_MS = 3 * 60 * 1000; // 3 minutes — exceeds any realistic fulfillment API timeout
